import React from "react";

const DisableWrapper = ({
  disabled = false,
  children,
  opacity = 0.6,
  style = {},
  ...rest
}) => {
  const wrapperStyle = disabled
    ? {
        pointerEvents: "none",
        cursor: "not-allowed",
        opacity,
        ...style
      }
    : style;

  return (
    <div style={wrapperStyle} {...rest}>
      {children}
    </div>
  );
};

export default DisableWrapper;
